import Cookies from "js-cookie";
import { ICookieConfig, AUTH_SESSION_COOKIE } from "./setCookie";

const createConfigFromCookie = () => {
	const cookie = Cookies.get(AUTH_SESSION_COOKIE);
	if (!cookie) return undefined;
	return JSON.parse(cookie) as ICookieConfig;
};

export default createConfigFromCookie;
